class cAjax {

    /**
     * @constructs cAjax
     * @param {string} url
     * @param {callback} callbackFunction
     */
    constructor(url, callbackFunction) {
        var that = this;
        this.updating = false;

        this.update = function (passData, postMethod) {
            if (that.updating) {
                return false;
            }
            that.AJAX = null;

            if (window.XMLHttpRequest) {
                that.AJAX = new XMLHttpRequest();
            } else {
                that.AJAX = new ActiveXObject("Microsoft.XMLHTTP");
            }

            if (that.AJAX == null) {
                return false;
            } else {
                that.AJAX.onreadystatechange = function () {
                    if (that.AJAX.readyState == 4) {
                        that.updating = false;
                        that.callback(that.AJAX.responseText, that.AJAX.status, that.AJAX.responseXML);
                        that.AJAX = null;
                    }
                };

                that.updating = new Date();
                var uri;
                if (/post/i.test(postMethod)) {
                    uri = urlCall + '?' + that.updating.getTime();
                    that.AJAX.open("POST", uri, true);
                    that.AJAX.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                    that.AJAX.send(passData);
                } else {
                    passData = passData.length ? '?' + passData : '';
                    uri = urlCall + passData; // + '&ts=' + (that.updating.getTime());
                    that.AJAX.open("GET", uri, true);
                    that.AJAX.send(null);
                }
                return true;
            }
        };
        var urlCall = url;
        this.callback = callbackFunction || function () { };
    }
}
